(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mniowig-form-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mniowig-form-feedback')) {
    customElements.define('mniowig-form-feedback', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.bound = new WeakSet();
        this.timers = new Map();
        this.storageKey = 'mnw-form-pending-v1';
        this.bindForms();
        document.addEventListener('shopify:section:load', () => this.bindForms(), { signal: this.controller.signal });
        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          document.querySelectorAll('form[data-mnw-feedback]').forEach(form => this.reset(form));
          this.clearPending();
        }, { signal: this.controller.signal });
      }
      readPending() {
        try {
          const pending = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
          return pending && typeof pending.id === 'string' && Date.now() - pending.time < 1800000 ? pending : null;
        } catch { return null; }
      }
      clearPending() {
        try { sessionStorage.removeItem(this.storageKey); } catch {}
      }
      showMessage(form, text) {
        const message = form.querySelector('[data-mnw-form-message]');
        if (!message) return;
        message.textContent = text || '';
        message.hidden = !text;
      }
      reset(form) {
        window.clearTimeout(this.timers.get(form));
        this.timers.delete(form);
        form.removeAttribute('aria-busy');
        this.showMessage(form, '');
      }
      bindForms() {
        document.querySelectorAll('form[data-mnw-feedback]').forEach(form => {
          if (this.bound.has(form)) return;
          this.bound.add(form);
          const options = { signal: this.controller.signal };
          form.addEventListener('invalid', event => {
            this.reset(form);
            this.showMessage(form, event.target.validationMessage);
          }, { ...options, capture: true });
          form.addEventListener('submit', () => {
            this.reset(form);
            this.showMessage(form, this.dataset.submitting);
            form.setAttribute('aria-busy', 'true');
            try {
              sessionStorage.removeItem('mnw-welcome-pending');
              sessionStorage.setItem(this.storageKey, JSON.stringify({ id: form.id, time: Date.now() }));
            } catch {}
            this.timers.set(form, window.setTimeout(() => {
              form.removeAttribute('aria-busy');
              this.showMessage(form, this.dataset.waiting);
            }, 15000));
          }, { ...options, capture: true });
          const pending = this.readPending();
          const ownReturn = window.location.hash === '#' + form.id || pending?.id === form.id;
          const result = form.querySelector('[data-mnw-form-result]');
          if (result && ownReturn) {
            this.clearPending();
            result.focus({ preventScroll: true });
            result.scrollIntoView({ block: 'center', behavior: 'instant' });
          } else if (pending?.id === form.id) {
            this.clearPending();
            this.showMessage(form, this.dataset.unconfirmed);
            const message = form.querySelector('[data-mnw-form-message]');
            message?.focus({ preventScroll: true });
            message?.scrollIntoView({ block: 'center', behavior: 'instant' });
          }
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.timers?.forEach(timer => window.clearTimeout(timer));
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
